import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import toast from "react-hot-toast"
import { es, de as deDe, it, enUS } from "date-fns/locale"

import PhoneInput from "react-phone-input-2"
import de from 'react-phone-input-2/lang/de.json'
import 'react-phone-input-2/lib/style.css'

import { DayPicker } from "react-day-picker"
import "react-day-picker/dist/style.css"

import { Checkbox } from "@headlessui/react"

import {
    useCashPaymentMutation,
    useCreateHostedTokenizationPaymentMutation,
    useGetHostedTokenizationUrlQuery
} from "../../../../services/payments_api"

import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
// import HostedTokenization from "../../common/hosted_tokenization/HostedTokenization"
import Spinner from "../../../ui/spinner"
import { CalendarDays } from "lucide-react"
import sumupLogo from "../../../../assets/sumup-logo.svg"

import { formatPrice } from "../../../../utils/format/formatPrice"
import { formatTimeHHmm } from "../../../../utils/format/formatTime"
// import { formatSimpleDate } from "../../../../utils/format/formatSimpleDate"
import { getLocalStorageItem } from "../../../../utils/local_storage/local_storage"
import { getTimeOptions } from "../../../../utils/get/getTimeOptions"

import { RootState } from "../../../../store/store"
import { DateTime } from "luxon"
import { setTableId } from "../../../../store/shop_order/shopOrderSlice"

export const formatSimpleDate = (date: Date) => {
    return DateTime.fromJSDate(date)
        .setZone(TIMEZONE)
        .toFormat("dd.MM.yy")
}


// Constant for Zurich timezone
const TIMEZONE = "Europe/Zurich"

const CheckoutForm = () => {

    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const order = useSelector((state: RootState) => state.shopOrder)

    const expiryMonthRef = useRef(null);
    const expiryYearRef = useRef(null);
    const cvvRef = useRef(null);

    const [handlePayment] = useCashPaymentMutation()

    // const { data: hostedTokenizationData } = useGetHostedTokenizationUrlQuery({})
    // const [createHostedTokenizationPayment, { isLoading }] = useCreateHostedTokenizationPaymentMutation()

    const [locale, setLocale] = useState(null)
    const [details, setDetails] = useState(order.details)
    const [loading, setLoading] = useState(false)
    // const [selectedDate, setSelectedDate] = useState(new Date())
    const [selectedDate, setSelectedDate] = useState(
        DateTime.now().setZone(TIMEZONE).startOf("day").toJSDate()
    )
    const timeOptions = getTimeOptions(0, selectedDate)
    const [selectedTime, setSelectedTime] = useState<Date>(
        timeOptions[0] || DateTime.now().setZone(TIMEZONE).toJSDate()
    )

    const tableId = getLocalStorageItem("table-id")

    console.log("table id >>> ", tableId)

    const [openCalendar, setOpenCalendar] = useState(false)
    const [scheduled, setScheduled] = useState(false)
    const [cardDetails, setCardDetails] = useState({
        card_name: '',
        number: '',
        expiry_month: '',
        expiry_year: '',
        cvv: ''
    })

    // const hostedTokenizationRef = useRef(null)
    // const tokenizerRef = useRef(null)

    const handleCustomerData = (e) => {
        setDetails({
            ...details,
            customer_data: {
                ...details.customer_data,
                [e.target.name]: e.target.value
            }
        })
    }

    const handlePhoneInput = (value) => {
        setDetails({
            ...details,
            customer_data: {
                ...details.customer_data,
                phone: value
            }
        })
    }

    const handlePostCodeInput = (e) => {
        const value = e.target.value;
        // Ensure only numeric values and limit to 4 characters
        if (/^\d{0,4}$/.test(value)) {
            handleCustomerData(e)
        }
    }

    // const handleSelectedTime = (e) => setSelectedTime(e.target.value)
    const handleSelectedTime = (e) => {
        const isoString = e.target.value
        const asDate = new Date(isoString)
        setSelectedTime(asDate)  // parse back to Date
    }

    const handleDayClick = (day: Date, { selected }: { selected: boolean }) => {
        // Prevent unselecting if the date is already selected
        if (selected) return

        setSelectedDate(day)
    }

    const handleCardDetails = (e) => {
        setCardDetails({
            ...cardDetails,
            [e.target.name]: e.target.value
        })
    }

    const handleCardDetailsWithAutoTab = (e, nextRef) => {
        handleCardDetails(e);
        if (e.target.value.length >= 2 && nextRef?.current) {
            nextRef.current.focus();
        }
    }

    const handleCashPayment = async () => {

        const tableId = getLocalStorageItem("table-id")

        const enhancedDetails = {
            ...details,
            payment_status: "pending",
            created_at: new Date().toISOString(),
            created_by: "ecommerce",
            order_type: details.order_type,
            // selected_date_time: `${formatSimpleDate(selectedDate)} - ${selectedTime}`,
            selected_date_time: `${formatSimpleDate(selectedDate)} - ${formatTimeHHmm(selectedTime)}`,
            table: tableId,
            scheduled,
        }

        try {
            const response = await handlePayment({
                cart: order.cart,
                details: enhancedDetails,
                status: 'process',
                locale: i18n.language
            })

            if ('error' in response) {
                return toast.error("Error processing order")
            }

            navigate(`/success?order_id=${response.data.orderId}&is_table=${response.data.isTable}&table_id=${response.data.tableId}`)

        } catch (error) {
            toast.error("Error processing payment")
        } finally {
            setLoading(false)
        }
    }

    // const handleHostedTokenizerPayment = async () => {

    //     const enhancedDetails = {
    //         ...details,
    //         payment_status: "pending",
    //         created_by: "ecommerce",
    //         order_type: details.order_type,
    //         selected_date_time: `${formatSimpleDate(selectedDate)} - ${selectedTime}`
    //     }

    //     // if (!hostedTokenizationRef.current) return toast.error("Error processing the form")

    //     if (tokenizerRef.current) {

    //         const tokenizationSubmitResponse = await tokenizerRef.current.submitTokenization()

    //         console.log("tokenization submit response >>>> ", tokenizationSubmitResponse)

    //         if (!tokenizationSubmitResponse.success) {
    //             console.log("Error during tokenization submit")
    //             setLoading(false)
    //             return toast.error("Error submiting your payment details")
    //         }

    //         const paymentData = {
    //             cart: order.cart,
    //             details: enhancedDetails,
    //             hostedTokenizationId: hostedTokenizationData.body.hostedTokenizationId
    //         }

    //         const tokenizationPaymentResponse = await createHostedTokenizationPayment(paymentData)

    //         console.log("tokenization payment response >>>> ", tokenizationPaymentResponse)

    //         // if (!tokenizationPaymentResponse.success) {
    //         //     console.log("Error during tokenization payment creation")
    //         //     setLoading(false)
    //         //     return toast.error("Error submiting your payment details")
    //         // }

    //         // return history.replace(`/ecommerce/success?order_id=${response.data.orderId}&is_table=${response.data.isTable}`)

    //     }

    //     setLoading(false)
    // }

    const handleSumupCheckout = async () => {

    }

    const handleSubmit = (e) => {

        e.preventDefault()

        setLoading(true)

        // if (details.order_type !== "onsite" && details.customer_data.address === "") return toast.error("Provide an address")
        if (details.customer_data.phone === "" && !tableId) {
            setLoading(false)
            return toast.error("Bitte geben Sie eine Telefonnummer an")
        }

        // if (details.payment_method === "online") handleHostedTokenizerPayment()

        if (details.payment_method === "cash") handleCashPayment()

        // if (details.payment_method === "online") {

        //     if (
        //         cardDetails.card_name.length === 0 ||
        //         cardDetails.number.length === 0 ||
        //         cardDetails.expiry_month.length === 0 ||
        //         cardDetails.expiry_year.length === 0 ||
        //         cardDetails.cvv.length === 0
        //     ) return toast.error('Bitte vervollständigen Sie Ihre Kartendetails')

        //     handleSumupCheckout()
        // }

    }

    useEffect(() => {
        // Handle locales
        switch (i18n.language) {
            case "en":
                return setLocale(enUS)
            case "de":
                return setLocale(deDe)
            case "it":
                return setLocale(it)
            case "es":
                return setLocale(es)
            default:
                return setLocale(deDe)
        }
    }, [t])

    useEffect(() => {
        if (tableId) {
            console.log("table id >>> ", tableId)
            dispatch(setTableId(Number(tableId)))
        }
    }, [tableId])

    console.log("order > ", order)

    return <form onSubmit={handleSubmit} className="flex flex-col gap-4" autoComplete="off">
        <div className="flex flex-col gap-2">
            <input type="text" style={{ display: 'none' }} />
            <input
                type="text"
                name="name"
                value={details.customer_data.name}
                onChange={handleCustomerData}
                className="input-field"
                placeholder="Vorname"
                autoComplete="off"
                required
            />
            <input
                type="email"
                name="email"
                value={details.customer_data.email}
                onChange={handleCustomerData}
                className="input-field"
                placeholder="Email"
                autoComplete="off"
                required
            />
            {
                !order.details.table ?
                    <>
                        <
                            PhoneInput
                            onChange={(value) => handlePhoneInput(value)}
                            inputProps={{
                                name: 'phone',
                                required: true,
                            }}
                            countryCodeEditable={false}
                            containerClass="flex"
                            inputClass="!py-2 !border !border-zinc-200 !rounded-md !text-base !h-auto flex-1"
                            localization={de}
                            country="ch"
                            preferredCountries={["ch", "de", "it", "fr", "gb", "es", "at"]}
                        />
                        {
                            details.order_type === "delivery" &&
                            <>
                                <input
                                    type="text"
                                    name="address"
                                    id="address"
                                    value={details.customer_data.address}
                                    onChange={handleCustomerData}
                                    className="input-field"
                                    placeholder={t("checkout-form.address")}
                                    required
                                />
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        name="postcode"
                                        id="postcode"
                                        value={details.customer_data.postcode}
                                        onChange={handlePostCodeInput}
                                        maxLength={4}
                                        className="input-field flex-1"
                                        placeholder={t("checkout-form.postcode")}
                                    />
                                    <input
                                        type="text"
                                        name="city"
                                        id="city"
                                        value={details.customer_data.city}
                                        onChange={handleCustomerData}
                                        className="input-field flex-1"
                                        placeholder={t("checkout-form.city")}
                                    />
                                </div>
                            </>
                        }
                        <textarea
                            rows={2}
                            name="notes"
                            placeholder="Bemerkung"
                            className="flex-1 input-field resize-none rounded-md"
                            onChange={handleCustomerData}
                        />

                        {/* ORDER TYPE */}
                        <div className="flex flex-col sm:flex-row gap-2 mt-4">
                            <button
                                onClick={() => setDetails({ ...details, order_type: "delivery" })}
                                type="button"
                                className={`${details.order_type === "delivery" && "bg-zinc-100 outline"} flex-1 shop-secondary-button border-zinc-200 h-full flex items-center justify-center gap-4`}
                            // disabled={true}
                            >
                                {
                                    details.order_type === "delivery" ?
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8 text-green-500">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                            </svg>
                                        </span> : null
                                }
                                {t("landing.delivery")}
                            </button>
                            <button
                                onClick={() => setDetails({ ...details, order_type: "tkw" })}
                                type="button"
                                className={`${details.order_type === "tkw" && "bg-zinc-100 outline"} flex-1 shop-secondary-button border-zinc-200 h-full flex items-center justify-center gap-4`}
                            >
                                {
                                    details.order_type === "tkw" ?
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8 text-green-500">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                            </svg>
                                        </span> : null
                                }
                                {t("landing.takeaway")}
                            </button>
                        </div>

                        {/* SCHEDULE */}
                        <div className="space-y-4 mt-6">
                            <div className="flex gap-2">
                                <p>Möchten Sie Ihre Bestellung planen?</p>
                                <Checkbox
                                    checked={scheduled}
                                    onChange={setScheduled}
                                    className="cols-span-1 flex gap-x-4 group cursor-pointer overflow-hidden truncate"
                                >
                                    <svg
                                        className="stroke-white min-w-6 h-6 bg-white group-data-[checked]:bg-blue-500 rounded border border-zinc-300"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                    >
                                        <path
                                            d="M3 8L6 11L11 3.5"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Checkbox>
                            </div>
                            <div className={`flex gap-2 ${scheduled ? "max-h-[1000]" : "max-h-0 overflow-hidden"} transition-all`}>
                                <button
                                    type="button"
                                    className="p-2 flex gap-2 items-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    onClick={() => setOpenCalendar(true)}
                                >
                                    <CalendarDays size={18} strokeWidth={1.5} />
                                    <span>{formatSimpleDate(selectedDate)}</span>
                                </button>
                                <Dialog
                                    open={openCalendar}
                                    onClose={() => setOpenCalendar(false)}
                                    className="relative z-50"
                                >
                                    <DialogBackdrop
                                        transition
                                        className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                                    />
                                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                            <DialogPanel
                                                transition
                                                className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                                            >
                                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                                    <div
                                                        onClick={(e) => e.stopPropagation()}
                                                        className="w-full flex flex-col gap-2"
                                                    >
                                                        <DayPicker
                                                            mode="single"
                                                            selected={selectedDate}
                                                            onDayClick={handleDayClick}
                                                            disabled={{
                                                                before: new Date(), // Disable all days before today
                                                            }}
                                                            locale={locale}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="mt-4 shop-primary-button"
                                                            onClick={() => setOpenCalendar(false)}
                                                        >
                                                            Ok
                                                        </button>
                                                    </div>
                                                </div>
                                            </DialogPanel>
                                        </div>
                                    </div>
                                </Dialog>

                                <select
                                    onChange={handleSelectedTime}
                                    className="p-2 flex gap-2 items-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    id="timeSelect"
                                    name="timeSelect"
                                >
                                    {
                                        timeOptions.map((time, index) => (
                                            // <option key={index} value={formatTime(time)}>
                                            //     {formatTime(time)}
                                            // </option>
                                            <option key={index} value={time}>
                                                {formatTimeHHmm(time)}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                    </> : null
            }
        </div>

        {/* PAYMENT METHOD */}
        <div className="flex flex-col sm:flex-row gap-2">
            <button
                onClick={() => setDetails({ ...details, payment_method: "cash" })}
                type="button"
                className={`${details.payment_method === "cash" && "bg-zinc-100 outline outline-zinc-800"} relative flex-1 shop-secondary-button border-zinc-200 h-16 flex items-center justify-center gap-4`}
            >
                {t("checkout-form.cash")}
            </button>
            <button
                onClick={() => setDetails({ ...details, payment_method: "online" })}
                type="button"
                className={`${details.payment_method === "online" && "bg-zinc-100 outline outline-zinc-800"} flex-1 shop-secondary-button border-zinc-200 h-16 flex items-center justify-center gap-4`}
                // disabled={!sumupResourceReference}
                disabled
            >
                {t("checkout-form.credit")}
                <span className="text-[6px] flex gap-1 items-center"> powered by <img src={sumupLogo} className="w-12 h-12" /></span>
            </button>
        </div>

        <div className={`${details.payment_method === "online" ? "max-h-[1000] my-4 p-4 bg-zinc-100 rounded-md " : "max-h-0"} overflow-hidden space-y-2 transition-all`}>
            <p className="font-semibold">Zahlungsdetails</p>
            <input
                type="text"
                name="card_name"
                value={cardDetails.card_name}
                onChange={handleCardDetails}
                className="input-field bg-white"
                placeholder="Name auf der Karte."
                required={details.payment_method === "online"}
            />
            <input
                type="text"
                name="number"
                value={cardDetails.number}
                onChange={handleCardDetails}
                className="input-field bg-white"
                placeholder="Kartennummer"
                required={details.payment_method === "online"}
            />
            <div className="flex gap-2">
                <div className="flex flex-col gap-1">
                    <label className="text-sm">Ablaufmonat</label>
                    <input
                        ref={expiryMonthRef}
                        type="text"
                        name="expiry_month"
                        value={cardDetails.expiry_month}
                        onChange={(e) => handleCardDetailsWithAutoTab(e, expiryYearRef)}
                        className="input-field bg-white"
                        placeholder="MM"
                        maxLength={2}
                        required={details.payment_method === "online"}
                    />
                </div>
                <div className="flex flex-col gap-1">
                    <label className="text-sm">Ablaufjahr</label>
                    <input
                        ref={expiryYearRef}
                        type="text"
                        name="expiry_year"
                        value={cardDetails.expiry_year}
                        onChange={(e) => handleCardDetailsWithAutoTab(e, cvvRef)}
                        className="input-field bg-white"
                        placeholder="YY"
                        maxLength={2}
                        required={details.payment_method === "online"}
                    />
                </div>
                <div className="flex flex-col gap-1">
                    <label className="text-sm">CVV</label>
                    <input
                        ref={cvvRef}
                        type="text"
                        name="cvv"
                        value={cardDetails.cvv}
                        onChange={handleCardDetails}
                        className="input-field bg-white"
                        placeholder="CVV"
                        required={details.payment_method === "online"}
                    />
                </div>
            </div>
        </div>

        <div className="flex gap-2 h-16 mt-12 sm:mt-4">
            <button type="button" onClick={() => navigate(-1)} className="shop-secondary-button flex-[1] border-zinc-200">
                {t("checkout-form.return")}
            </button>
            <button
                className="shop-primary-button flex-[2] flex items-center"
                type="submit"
                disabled={loading}
            >
                {loading ? <Spinner color="text-zinc-500" /> : `${t("checkout-form.order")} (CHF ${formatPrice(order.cart.total)})`}
            </button>
        </div>
    </form >
}

export default CheckoutForm